<template>
    <p class="my20">
        {{ $t('coupons.editor.rules.empty') }}
    </p>
</template>

<script>
    export default {
        name: 'RuleEmptyItem',
    };
</script>
